import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './VolunteerSection.css';

const VolunteerSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const publicUrl = process.env.PUBLIC_URL || '';
  const volunteerBackground = `linear-gradient(135deg, rgba(255, 111, 41, 0.9) 0%, rgba(255, 140, 64, 0.72) 100%), url(${publicUrl}/images/image4.jpeg)`;
  const donationBackground = `linear-gradient(135deg, rgba(20, 20, 20, 0.88) 0%, rgba(32, 32, 32, 0.92) 100%), url(${publicUrl}/images/image5.jpeg)`;
  const qrCodeSrc = `${publicUrl}/images/qrcode.jpg`;
  const volunteerFeatures = [
    t('volunteer_section_donate_money'),
    t('volunteer_section_handle_with_care'),
    t('volunteer_section_donate_money')
  ];

  return (
    <section className="volunteer-section">
      <div className="volunteer-container">
        <div
          className="volunteer-card volunteer-left"
          style={{ backgroundImage: volunteerBackground }}
        >
          <div className="card-content">
            <h2>{t('volunteer_section_become_volunteer_title')}</h2>
            <p>{t('volunteer_section_become_volunteer_description')}</p>
            <div className="card-features">
              {volunteerFeatures.map((feature, index) => (
                <span key={index} className="feature">
                  {feature}
                </span>
              ))}
            </div>
            <button className="btn btn-volunteer" onClick={() => navigate('/contact')}>
              <span className="btn-icon">▶</span>
              {t('volunteer_section_become_volunteer_button')}
            </button>
          </div>
        </div>

        <div
          className="volunteer-card volunteer-right"
          style={{ backgroundImage: donationBackground }}
        >
          <div className="card-content">
            <h2>{t('volunteer_section_send_gift_title')}</h2>
            <div className="qr-block">
              <div className="qr-card">
                <img src={qrCodeSrc} alt={t('volunteer_section_qr_alt')} />
                <p>{t('volunteer_section_qr_caption')}</p>
              </div>
            </div>

            {/* <button className="btn btn-donate">
              <span className="btn-icon">▶</span>
              Donate Now
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerSection;
